var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-90 0 48)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_44383)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14C18.477 14 14 18.477 14 24C14 29.523 18.477 34 24 34C29.523 34 34 29.523 34 24C34 18.477 29.523 14 24 14ZM20 20C20 19.7348 20.1054 19.4804 20.2929 19.2929C20.4804 19.1054 20.7348 19 21 19H27C27.2652 19 27.5196 19.1054 27.7071 19.2929C27.8946 19.4804 28 19.7348 28 20C28 20.2652 27.8946 20.5196 27.7071 20.7071C27.5196 20.8946 27.2652 21 27 21H25.465C25.644 21.31 25.783 21.645 25.874 22H27C27.2652 22 27.5196 22.1054 27.7071 22.2929C27.8946 22.4804 28 22.7348 28 23C28 23.2652 27.8946 23.5196 27.7071 23.7071C27.5196 23.8946 27.2652 24 27 24H25.874C25.7204 24.5928 25.4331 25.1426 25.034 25.6072C24.635 26.0717 24.1349 26.4387 23.572 26.68L25.6 28.2C25.8122 28.3591 25.9524 28.596 25.9899 28.8586C26.0275 29.1211 25.9591 29.3878 25.8 29.6C25.6409 29.8122 25.404 29.9524 25.1414 29.99C24.8789 30.0275 24.6122 29.9591 24.4 29.8L20.408 26.806C20.2807 26.7139 20.1772 26.5927 20.1063 26.4525C20.0353 26.3123 19.9989 26.1571 20 26C20 25.743 20.103 25.496 20.27 25.317C20.3629 25.2163 20.4759 25.1361 20.6016 25.0815C20.7273 25.0269 20.863 24.9992 21 25H22C22.3511 25 22.6959 24.9076 23 24.732C23.304 24.5565 23.5565 24.304 23.732 24H21C20.7348 24 20.4804 23.8946 20.2929 23.7071C20.1054 23.5196 20 23.2652 20 23C20 22.7348 20.1054 22.4804 20.2929 22.2929C20.4804 22.1054 20.7348 22 21 22H23.732C23.5565 21.696 23.304 21.4435 23 21.268C22.6959 21.0924 22.3511 21 22 21H21C20.7348 21 20.4804 20.8946 20.2929 20.7071C20.1054 20.5196 20 20.2652 20 20Z",
    fill: "#454CF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_44383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.d1a309b6c9199c468ea0b341535ae466.svg";
export { ForwardRef as ReactComponent };